import { MAX_TABLET_WIDTH } from '@src/util/constants'

const MOBILE_VIEW_KEYS = {
  'PAGE.MEMBERS.TRAINING.HISTORY.RANGE_OF_MOTION': 'PAGE.MEMBERS.TRAINING.HISTORY.MOBILE.RANGE_OF_MOTION',
  'PAGE.MEMBERS.TRAINING.HISTORY.PIX_SCORE': 'PAGE.MEMBERS.TRAINING.HISTORY.MOBILE.PIX_SCORE'
}

export function getKeyByView (key: string) {
  let viewKey = key
  if (window.innerWidth <= MAX_TABLET_WIDTH) {
    viewKey = MOBILE_VIEW_KEYS[key] || key
  }

  return viewKey
}
